import React, { useState } from "react";
import {Helmet} from "react-helmet";
import QuestionCounter from "../../components/common/questionCounter";
import { AiOutlineClose } from "react-icons/ai";
import HeaderVirtualFair from "../../components/common/headerVertualFair"
import IdpQuitPopup from "../../components/common/idp-quit-popup"
import IdpVirtualFairForm from "../../components/idp-vertual-fair/idpVirtualFair"
import { Container } from "react-bootstrap";
import "../../assets/css/virtual-fair.css";


const IdpVirtualFair = () => {
  const [isIdpPopupShow, setIsIdpPopupShow] = useState(false)
  const handlePopup = (popup)=>{
    setIsIdpPopupShow(popup)
  }
  
  return (<>
    <Helmet>
        <title>IDP Virtual Fair</title>
    </Helmet>
    <div className="idp_wrapper idp_virtualfair">
      <HeaderVirtualFair handlePopup={handlePopup}/>
      <Container>
        <IdpVirtualFairForm/>
      </Container>
    </div>
    {isIdpPopupShow && <IdpQuitPopup handlePopup={handlePopup}/>}
    </>);
};

export default IdpVirtualFair;